// Single source of truth for section-label → colour mapping used in the
// approval inbox and my-submissions tables. Matched by sectionLabel (human-
// readable), not by raw contentType, so the `includes` checks are intentional.
export function getSectionStyle(label) {
  const l = label?.toLowerCase() || '';
  if (l.includes('charity'))    return { bg: '#fdf4ff', color: '#7c3aed', border: '#e9d5ff' };
  if (l.includes('item'))       return { bg: '#eff6ff', color: '#1d4ed8', border: '#bfdbfe' };
  if (l.includes('booth'))      return { bg: '#f0fdf4', color: '#15803d', border: '#bbf7d0' };
  if (l.includes('portal'))     return { bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' };
  if (l.includes('hosting'))    return { bg: '#fefce8', color: '#a16207', border: '#fef08a' };
  if (l.includes('advertiser')) return { bg: '#fff1f2', color: '#be123c', border: '#fecdd3' };
  if (l.includes('media'))       return { bg: '#f0f9ff', color: '#0369a1', border: '#bae6fd' };
  if (l.includes('discount'))    return { bg: '#f5f3ff', color: '#6d28d9', border: '#ddd6fe' };
  if (l.includes('recognition')) return { bg: '#ecfdf5', color: '#047857', border: '#6ee7b7' };
  if (l.includes('game'))        return { bg: '#ecfeff', color: '#0e7490', border: '#a5f3fc' };
  return { bg: '#f8fafc', color: '#475569', border: '#e2e8f0' };
}
